export default "__VITE_ASSET__BuFJ_k1N__"